<script lang="ts">
  import { ButtonColor, IconType } from "$types/atoms";
  import ResearchInsightsPostCard from "$lib/molecules/newsroom/cards/ResearchInsightsPostCard.svelte";
  import ResearchInsightsLargePostCard from "$lib/molecules/newsroom/cards/ResearchInsightsLargePostCard.svelte";
  import Button from "$lib/atoms/Button.svelte";

  export let posts: any;
</script>

<div class="research-insights-grid">
  <div class="grid sm:grid-cols-2 lg:row-span-2 gap-[1.5rem]">
    {#if posts.length >= 3}
      {#if posts[0]}
        <ResearchInsightsLargePostCard post={posts[0]} />
      {/if}

      {#if posts[1]}
        <ResearchInsightsPostCard post={posts[1]} />
      {/if}

      {#if posts[2]}
        <ResearchInsightsPostCard post={posts[2]} />
      {/if}
    {:else}
      {#if posts[0]}
        <ResearchInsightsLargePostCard post={posts[0]} />
      {/if}
      {#if posts[1]}
        <ResearchInsightsLargePostCard post={posts[1]} />
      {/if}
    {/if}
  </div>
</div>
